
:host([class~="header"]){
  gz-text {
    --font-family: 'Montserrat', sans-serif;
    font-weight: 600;
  }
  gz-checkbox,
  gz-radio {
    font-weight: 600;
    --main-titles-inputs-600: var(--body-text-arrows-400);
  }
  gz-checkbox {
    --label-font-family: 'Montserrat', sans-serif;
    --label-font-size: var(--body-size);
  }
  gz-radio {
    --font-family: 'Montserrat', sans-serif;
    --font-size: var(--body-size);
  }
}

.view-table {
  display: table;
  width: 100%;
  border-collapse: collapse;
}

.view-row {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid var(--chart-101-pressed-dividers);
  height: calc(4 * var(--spacer));
}

gz-radio-group {
  display: flex;
  flex: 3;
  margin-bottom: 0;
}

.view-cell {
  display: flex;
  align-items: center;
  flex: 1;
}

.view-cell.first-cell {
  flex: 2;
  padding-left: 20px;
}

gz-radio {
  margin-bottom: 0;
}

gz-tooltip {
  pointer-events: inherit;
}
